export default __webpack_public_path__ + "logo.375942f5.svg";